import { Formik } from 'formik'
import { useEffect, useState } from 'react'
import { Container, Form } from 'reactstrap'
import Message from '../../utility/notifications/Message'
import Notify from '../../utility/notifications/Notify'
import AppTextInput from '../components/forms/AppTextInput'
import { useNavigate } from 'react-router-dom'

import { SubmitButton } from '../components/buttons/SubmitButton'
import Page from '../components/Page'
import {
  getProjectExternalItemMapping,
  processProjectExternalItemMapping
} from '../../services/ExternalItemMappingService'

export interface ExternalItemMappingTabInterface {
  projectId: number
}

const ExternalItemMappingTab = ({ projectId }: ExternalItemMappingTabInterface) => {
  const navigate = useNavigate()

  const [itemData, setItemData] = useState([])
  const [loading, setLoading] = useState(false)
  const [saving, setSaving] = useState(false)

  useEffect(() => {
    fetchItems()
  }, [projectId])

  async function fetchItems() {
    setLoading(true)
    const response = await getProjectExternalItemMapping(projectId)

    const items = response.data.result.items

    const grouped = items.reduce((acc: any, item: any) => {
      if (!acc[item.itemId]) {
        acc[item.itemId] = {
          itemId: item.itemId,
          itemName: item.itemName,
          itemCodesType0: null,
          itemCodesType1: null,
          itemCodesType2: null
          // itemCodesType3: null
        }
      }

      // Zet value direct op de juiste property
      acc[item.itemId][`itemCodesType${item.type}`] = item.value

      return acc
    }, {})

    const mappedObject = Object.values(grouped)

    setItemData(mappedObject)
    setLoading(false)
  }

  const deleteRemovedItems = () => {}

  async function handleSubmit(data) {
    setSaving(true)

    const items = []

    for (const item of data.items) {
      for (let type = 0; type <= 3; type++) {
        const key = `itemCodesType${type}`
        if (item[key] !== null && item[key] !== undefined) {
          items.push({
            id: 0,
            itemId: item.itemId,
            type: type,
            value: item[key]
          })
        }
      }
    }

    // Zet alles in één object
    const postData = {
      projectId,
      items
    }

    processProjectExternalItemMapping(postData)
      .then(res => {
        Notify.success(`Configuration has been saved`)
        setSaving(false)

        navigate(-1)
      })
      .catch(err => {
        setSaving(false)
        Message(err.response.data.error.message, err.response.data.error.details, 'error')
      })
  }

  if (!projectId) {
    return (
      <div className='mt-2'>
        <h5>You can configure articles after creating the project</h5>
      </div>
    )
  }

  return (
    <Page loading={loading} loadingMessage='Retrieving article configuration'>
      <div className='mt-2'>
        {!loading && itemData.length === 0 && (
          <h5>No article configurations found yet. First add items to configurate the external daily items</h5>
        )}

        <Formik
          enableReinitialize
          initialValues={{ items: itemData }}
          onSubmit={handleSubmit}
          //validationSchema={validationSchema}
        >
          {({ handleSubmit, values }) => (
            <Form onSubmit={handleSubmit} className='mt-2'>
              <Container fluid className='scrollable-container'>
                <div className='header-row'>
                  <div className='column-item-name'>Item name</div>
                  <div className='column-item-name'>CO</div>
                  <div className='column-item-name'>SO</div>
                  <div className='column-item-name'>SOL</div>
                </div>

                {values.items?.map((item, index) => (
                  <div className='content-row mb-2' key={index}>
                    <div className='column-item-name'>
                      <AppTextInput name={`items[${index}].itemName`} required />
                    </div>
                    <div className='column-item-name'>
                      <AppTextInput
                        key={`itemcode-co-key[${index}]`}
                        name={`items[${index}].itemCodesType0`}
                        numbersOnly={true}
                      />
                    </div>
                    <div className='column-item-name'>
                      <AppTextInput
                        key={`itemcode-so-key[${index}]`}
                        name={`items[${index}].itemCodesType1`}
                        numbersOnly={true}
                      />
                    </div>
                    <div className='column-item-name'>
                      <AppTextInput
                        key={`itemcode-col-key[${index}]`}
                        name={`items[${index}].itemCodesType2`}
                        numbersOnly={true}
                      />
                    </div>
                    {/* <div className='column-item-name'>
                      <AppTextInput
                        key={`itemcode-item-key[${index}]`}
                        name={`items[${index}].itemCodesType3`}
                        numbersOnly={true}
                      />
                    </div> */}
                  </div>
                ))}
              </Container>

              <div className='d-flex justify-content-between'>
                <SubmitButton disabled={saving} title='Save configuration' />
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </Page>
  )
}

export default ExternalItemMappingTab
